theme_custom.realPeoplePopupSlider = function () {
  $(".multiple_poup_slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    speed: 800,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          arrows: false,
        },
      },
    ],
  })
}
theme_custom.mainRealPeopleBlock = function () {
  $(".video_image_multiple").slick({
    slidesToShow: 2.3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.3,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.4,
          dots: true,
          arrows: false,
        },
      },
    ],
  })
}

theme_custom.multipleResultSlider = function () {
  const $slider = $(".multiple-result-sliders")
  $slider.on("init", function (event, slick) {
    if (window.innerWidth > 1024) {
      if (slick.slideCount <= 3) {
        if (!$slider.find(".slick-prev").length) {
          $slider
            .find(".slick-list")
            .before(
              '<button class="slick-prev slick-arrow cards-prev" aria-label="Previous" type="button">Previous</button>',
            )
        }
        if (!$slider.find(".slick-next").length) {
          $slider
            .find(".slick-list")
            .after(
              '<button class="slick-next slick-arrow cards-next" aria-label="Next" type="button">Next</button>',
            )
        }
        $slider.find(".slick-prev, .slick-next").each(function () {
          if ($(this).closest(".Color-Dark").length) {
            // Apply styles for buttons inside .Color-Dark
            $(this).css({
              "background-color": "background-color: rgba(255, 255, 255, 0.5)",
              "pointer-events": "none",
            })
          } else {
            // Apply default styles
            $(this).css({
              "background-color": "rgba(102, 102, 102, 0.2)",
              "pointer-events": "none",
            })
          }
        })

        $slider.find(".cards-prev").css({
          "background-image":
            "url('https://cdn.shopify.com/s/files/1/0872/9257/6044/files/disabled-left.svg?v=1738061527')",
        })
        $slider.find(".cards-next").css({
          "background-image":
            "url('https://cdn.shopify.com/s/files/1/0872/9257/6044/files/disabled-right.svg?v=1738061527')",
        })
        $slider.find(".slick-track").css({
          "margin-left": "0",
          "margin-right": "0",
        })
        $slider.find(".slick-dots").hide()
        $slider.parent().on("click", ".slick-prev", function () {
          $slider.slick("slickPrev")
        })
        $slider.parent().on("click", ".slick-next", function () {
          $slider.slick("slickNext")
        })
      }
    }
  })
  $(window).on("resize", function () {
    if (window.innerWidth > 1024) {
      $slider.slick("setPosition")
    }
  })

  const $colorDarkSlider = $(".Color-Dark .multiple-result-sliders")

  if ($colorDarkSlider.length) {
    $colorDarkSlider.on("afterChange", function (event, slick, currentSlide) {
      const $prevArrow = $colorDarkSlider.find(".slick-prev")
      const $nextArrow = $colorDarkSlider.find(".slick-next")

      // Reset all arrows to black
      if ($prevArrow.hasClass("slick-disabled")) {
        $prevArrow.css({
          "background-image":
            "url(https://cdn.shopify.com/s/files/1/0584/6990/8591/files/Icons_24px_c1ba36cc-044e-42d4-935b-c2892954b713.png?v=1720519035)",
        })
      }
      if ($nextArrow.hasClass("slick-disabled")) {
        $nextArrow.css({
          "background-image":
            "url(https://cdn.shopify.com/s/files/1/0584/6990/8591/files/Icons_24px.png?v=1720519013)",
        })
      }

      // Update arrow colors based on the current slide
      if (currentSlide > 0) {
        $prevArrow.css({
          "background-image":
            "url(https://cdn.shopify.com/s/files/1/0872/9257/6044/files/white-prev.svg?v=1737619090)",
        })
      }
      if (currentSlide < slick.slideCount - slick.options.slidesToShow) {
        $nextArrow.css({
          "background-image":
            "url(https://cdn.shopify.com/s/files/1/0872/9257/6044/files/white-next.svg?v=1737619070)",
        })
      }
    })
  }

  $slider.slick({
    slidesToShow: 3.5,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1.85,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.25,
          arrows: false,
        },
      },
    ],
  })
}

theme_custom.mainProductSlider = function () {
  $(document).ready(function () {
    $(".slider-for").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      fade: true,
      asNavFor: ".slider-nav",
    })

    let $sliderNav = $(".slider-nav")

    $sliderNav.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      vertical: true,
      arrows: true,
      asNavFor: ".slider-for",
      dots: false,
      infinite: false,
      focusOnSelect: true,
      verticalSwiping: true,
      centerMode: true,
      centerPadding: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5.2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    })
    function removeAriaHidden() {
      $(".slick-slide[aria-hidden='true']").removeAttr("aria-hidden")

      $(".slick-slide").each(function () {
        let $slide = $(this)
        let isHidden = $slide.attr("aria-hidden") === "true"
        let $button = $slide.find("button")

        $button.attr("tabindex", isHidden ? "-1" : "0")
        $button.attr("role", "tab")
        $slide.removeAttr("tabindex")
      })
    }

    function preventHiddenElementFocus() {
      $(document).on("focusin", function (event) {
        let $focusedElement = $(event.target)
        let $hiddenAncestor = $focusedElement.closest(
          '.slick-slide[aria-hidden="true"]',
        )

        if ($hiddenAncestor.length > 0) {
          setTimeout(() => {
            $focusedElement.blur()
            $(".slider-nav .slick-current button").focus()
          }, 10)
        }
      })
    }

    function watchAriaHiddenChanges() {
      new MutationObserver(() => removeAriaHidden()).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["aria-hidden"],
      })
    }

    $sliderNav.on("init afterChange", removeAriaHidden)

    removeAriaHidden()
    preventHiddenElementFocus()
    watchAriaHiddenChanges()
  })
}

// Function to handle slider reinitialization
theme_custom.percussiveMassageSlider = function () {
  const pmSlider = $(".multiple-video-massages").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 16000,
    fade: true,
    cssEase: "linear",
    initialSlide: 0,
  })
  if (pmSlider.slick("getSlick").slideCount > 1) {
    setTimeout(function () {
      $(".multiple-video-massages").slick("slickGoTo", 1) // Move to the second slid
    }, 100)
  }
}

setTimeout(function () {
  $(".multiple-video-massages").slick("slickNext")
}, 17000)

// Handle the last slide scenario
function handleLastSlide(slick) {
  const totalSlides = slick.slideCount

  if (slick.currentSlide === totalSlides - 1) {
    // Unslick (destroy) the current slider
    $(".multiple-video-massages").slick("unslick")

    // Reinitialize the slider and wait for 'init' to move to the second slide
    theme_custom.percussiveMassageSlider()
  }
}

// Listen to the 'beforeChange' event
$(document).on(
  "beforeChange",
  ".multiple-video-massages",
  function (event, slick, currentSlide) {
    handleLastSlide(slick)
  },
)

$(document).on(
  "afterChange",
  ".multiple-video-massages",
  function (event, slick, currentSlide) {
    console.log("Active slide index:", currentSlide) // Debugging the active slide index
    // You can also manually check the active class if needed
    const totalSlides = slick.slideCount // Get the total number of slides
    setTimeout(function () {
      // Check if the next slide is the last one
      if (currentSlide === totalSlides - 1) {
        setTimeout(function () {
          $(".multiple-video-massages").slick("slickGoTo", 1) // Move to the second slid
        }, 16000)
      }
    }, 500) // Delay to ensure the slider is initialized

    $(".multiple-video-massages .slick-slide").removeClass("slick-active")
    $(".multiple-video-massages .slick-slide")
      .eq(currentSlide)
      .addClass("slick-active")
  },
)

theme_custom.searchSortChange = function () {
  let selectedSortName = $(".multiple-custom-sort-options input:checked").attr(
    "data-sort",
  )
  $(".selected-sort-custom").text(selectedSortName)
  let filterCountFind = $(".mobile-facets__main.gradient input:checked").length
  if (filterCountFind > 0) {
    $(".custom-filter-counts").removeClass("hidden")
    $(".custom-filter-counts").text(filterCountFind)
  } else {
    $(".custom-filter-counts").addClass("hidden")
  }
}

document.addEventListener("DOMContentLoaded", function (event) {
  theme_custom.realPeoplePopupSlider()
  theme_custom.mainProductSlider()
  theme_custom.mainRealPeopleBlock()
  theme_custom.multipleResultSlider()
  setTimeout(function () {
    theme_custom.percussiveMassageSlider()
  }, 1000)
  theme_custom.searchSortChange()
  $(".multiple-video-massages").on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      $(this).removeClass("hide-dots-custom")
      $(".main-video-blocks").removeClass("active")
    },
  )
})

class HotspotModal extends HTMLElement {
  constructor() {
    super()
    this.modal = this.querySelector(".hotspot-modal")
    this.button = this.querySelector("button")

    this.button.addEventListener("click", this.toggleModal.bind(this))
  }

  toggleModal() {
    this.button.classList.toggle("button--active")
    this.modal.classList.toggle("hidden")
  }
}
customElements.define("hotspot-modal", HotspotModal)

class HeroMultiproductImage extends HTMLElement {
  constructor() {
    super()
    this.scrollTimeout = null
    this.productList = this.querySelector("ul")
    this.defaultAnimationDuration = 6

    this.segmentContainer = this.querySelector(".hero-mp-image__segments")
    this.segments =
      this.segmentContainer &&
      this.segmentContainer.querySelectorAll(".segment")
    this.productCards = this.querySelectorAll(".product-card-container")
    this.productCardSlider = this.querySelector(".product-card-slider")
  }

  static get observedAttributes() {
    return ["static", "default-animation-duration"]
  }

  connectedCallback() {
    const isStatic = this.getAttribute("static") || false
    if (isStatic && isStatic === "true") {
      return
    }
    const hMpImg = this
    window.addEventListener("resize", function (event) {
      // fix slide alignment issue on resize
      if (!hMpImg.productList.classList.contains("slide-target-card")) {
        hMpImg.productList.style.scrollBehavior = "auto"
        hMpImg.productList.scrollLeft =
          hMpImg.getActiveSegmentIndex() * hMpImg.productList.clientWidth
        hMpImg.productList.style.scrollBehavior = "smooth"
      }
    })
    this.setUp()
  }

  disconectedCallback() {
    this.cleanUp()
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "default-animation-duration": {
        this.defaultAnimationDuration = newValue || 6
        break
      }
      case "static": {
        if ((!oldValue || oldValue === "false") && newValue === "true") {
          this.cleanUp()
        } else if (oldValue === "true" && (!newValue || newValue === "false")) {
          this.setUp()
        }
        break
      }
    }
  }

  setUp() {
    let firstProductDuration = this.defaultAnimationDuration
    this.productList.querySelectorAll("li").forEach((productItem, index) => {
      const video = productItem.querySelector("video")
      const duration =
        (video && video.duration) || this.defaultAnimationDuration
      if (index === 0) {
        firstProductDuration = duration
      }
      this.segments[index].querySelector(".progress").style =
        `animation-duration: ${duration}s;`
    })
    if (this.productList.classList.contains("slide-target-card")) {
      let productCards = this.productList.querySelectorAll(
        ".product-card-container",
      )
      productCards.forEach((el) => (el.style.display = "none"))
      this.productCardSlider.innerHTML = this.productCards[0].innerHTML
      this.productCardSlider.classList.add("product-card-container")
    }

    this.scheduleScrollToNextProduct(firstProductDuration)
    this.querySelectorAll(".hero-mp-image__thumbnail button").forEach(
      (button) =>
        button.addEventListener("click", this.scrollToNextProduct.bind(this)),
    )
    this.querySelectorAll(".hero-mp-image__toggle-animation button").forEach(
      (button) =>
        button.addEventListener("click", this.toggleScrollSchedule.bind(this)),
    )
    this.querySelectorAll("button.hero-mp-sale__carousel-prev").forEach(
      (anchor) =>
        anchor.addEventListener("click", this.scrollToPrevProduct.bind(this)),
    )
    this.querySelectorAll("button.hero-mp-sale__carousel-next").forEach(
      (anchor) =>
        anchor.addEventListener("click", this.scrollToNextProduct.bind(this)),
    )
  }

  cleanUp() {
    clearTimeout(this.scrollTimeout)
    this.scrollTimeout = null

    this.querySelectorAll(".hero-mp-image__thumbnail button").forEach(
      (button) => button.removeEventListener("click", this.scrollToNextProduct),
    )
    this.querySelectorAll(".hero-mp-image__toggle-animation button").forEach(
      (button) =>
        button.removeEventListener("click", this.toggleScrollSchedule),
    )
    this.querySelectorAll("button.hero-mp-sale__carousel-prev").forEach(
      (anchor) => anchor.removeEventListener("click", this.scrollToPrevProduct),
    )
    this.querySelectorAll("button.hero-mp-sale__carousel-next").forEach(
      (anchor) => anchor.removeEventListener("click", this.scrollToNextProduct),
    )
  }

  scrollToProduct(scrollIndex) {
    this.segmentContainer
      .querySelector(".segment--active")
      .classList.remove("segment--active")
    this.segments[scrollIndex].classList.add("segment--active")
    const scrollProduct = this.productList.querySelectorAll("li")[scrollIndex]
    const video = scrollProduct.querySelector("video")
    if (video) {
      video.currentTime = 0
    }
    if (this.productList.classList.contains("slide-target-card")) {
      let newCard = this.productCards[scrollIndex].innerHTML
      jQuery(".product-card-slider")
        .css({ display: "block" })
        .fadeOut(500, () => {
          jQuery(".hero-mp-sale__carousel-current", this).html(scrollIndex + 1)
          jQuery(".product-card-slider", this).html(newCard).fadeIn()
        })
    } else {
      this.productList.scrollLeft = scrollIndex * this.productList.clientWidth
    }

    const duration = this.getStyleAnimationDuration(
      this.segments[scrollIndex].querySelector(".progress"),
    )
    if (!!this.scrollTimeout) {
      this.scheduleScrollToNextProduct(duration)
    }
  }

  getActiveSegmentIndex() {
    let activeSegmentIndex = 0
    for (let i = 0; i < this.segments.length; i++) {
      if (this.segments[i].classList.contains("segment--active")) {
        activeSegmentIndex = i
        break
      }
    }
    return activeSegmentIndex
  }
  scrollToPrevProduct() {
    let activeSegmentIndex = this.getActiveSegmentIndex()
    const scrollIndex =
      activeSegmentIndex === 0
        ? this.segments.length - 1
        : activeSegmentIndex - 1
    this.scrollToProduct(scrollIndex)
  }

  scrollToNextProduct() {
    let activeSegmentIndex = this.getActiveSegmentIndex()
    const scrollIndex =
      activeSegmentIndex === this.segments.length - 1
        ? 0
        : activeSegmentIndex + 1
    this.scrollToProduct(scrollIndex)
  }

  toggleScrollSchedule(event) {
    const toggleAnimationButton = event.currentTarget
    const hasResumed = toggleAnimationButton.classList.toggle("button--active")
    this.segmentContainer.classList.toggle("paused")

    if (hasResumed) {
      const animationProgress = this.segmentContainer.querySelector(
        ".segment--active .progress",
      )
      const duration = this.getStyleAnimationDuration(animationProgress)
      const remainingDuration =
        duration -
        (animationProgress.getAnimations()[0].currentTime / 1000 || 0)
      this.scheduleScrollToNextProduct(remainingDuration)
    } else {
      clearTimeout(this.scrollTimeout)
      this.scrollTimeout = null
    }

    this.productList.querySelectorAll("video").forEach((video) => {
      if (hasResumed) {
        video.play()
      } else {
        video.pause()
      }
    })
  }

  scheduleScrollToNextProduct(duration = this.defaultAnimationDuration) {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout)
    }

    this.scrollTimeout = setTimeout(
      this.scrollToNextProduct.bind(this),
      duration * 1000,
    )
  }

  getStyleAnimationDuration(el) {
    const duration = el.style.animationDuration
    return duration.substring(0, duration.length - 1)
  }
}
customElements.define("hero-multiproduct-image", HeroMultiproductImage)

const cookieKey = "united_activated"
const updateVisibility = () => {
  const isActive = getCookie(cookieKey) === "true"

  document
    .querySelectorAll(".mileage-tags")
    .forEach((el) => (el.style.display = isActive ? "flex" : "none"))
}

const getCookie = (name) => {
  const cookies = document.cookie.split("; ").reduce((acc, currentCookie) => {
    const [key, value] = currentCookie.split("=")
    acc[key] = value
    return acc
  }, {})
  return cookies[name]
}

// Function to execute when the DOM changes
function onDomChange(mutationsList, observer) {
  mutationsList.forEach((mutation) => {
    updateVisibility()
    // make whole product card clickable

    // for all products
    const cardBox = document.querySelectorAll(".card")
    for (var i = 0; i < cardBox.length; i++) {
      if (!cardBox[i].getAttribute("data-clickable")) {
        cardBox[i].setAttribute("data-clickable", true)
        cardBox[i].querySelector(".card__inner").addEventListener(
          "click",
          function (evnt) {
            const card = evnt.target.closest(".card")
            const prodUrl = card.getAttribute("data-prod-url")
            window.location.href = prodUrl
          },
          false,
        )
        const variantTogglers = cardBox[i].querySelectorAll(
          ".custom-swatches-check",
        )
        for (var i = 0; i < variantTogglers.length; i++) {
          variantTogglers[i].addEventListener(
            "click",
            function (evnt) {
              evnt.stopPropagation()
              const option = evnt.target
              for (var i = 0; i < variantTogglers.length; i++) {
                variantTogglers[i].classList.remove("active")
              }
              option.classList.add("active")
              const card = option.closest(".card")
              card.setAttribute(
                "data-prod-url",
                option.getAttribute("data-prod-url"),
              )
              let badgesClass = option.getAttribute("data-badges")
              let badgesCustomText = option.getAttribute(
                "data-custom-badge-text",
              )
              card
                .querySelector(".badges")
                .setAttribute("class", "badges" + badgesClass)
              if (badgesClass == " custom-badge" && badgesCustomText != "") {
                card.querySelector(".badges.custom-badge .new_tags").innerHTML =
                  badgesCustomText
              }
              if (badgesClass == " new" && badgesCustomText != "") {
                card.querySelector(".badges.new .new_tags").innerHTML =
                  badgesCustomText
              }
              const price = option.getAttribute("data-price")
              const sale = option.getAttribute("data-sale")
              const priceWrapper = card.querySelector(".price-item")
              if (sale != "") {
                priceWrapper.innerHTML = `<span class="sale_price_custom">${sale}</span> <span class="org_prod_price">${price}</span>`
              } else {
                priceWrapper.innerHTML = price
              }
              const hoverSrc = option.getAttribute("data-variant-hover")
              const hoverImage = card.querySelector(".card__media img.hover")
              if (hoverSrc && hoverImage) {
                hoverImage.src = hoverSrc
                hoverImage.srcset = hoverSrc
              }
            },
            false,
          )
        }
      }
    }

    // for popular product
    // const popularBox = document.querySelectorAll(".popular-product-block")

    // for (var i = 0; i < popularBox.length; i++) {
    //   const data_url = popularBox[i].getAttribute("data-prod-url")
    //   cardBox[i].addEventListener(
    //     "click",
    //     function () {
    //       window.location.href = data_url
    //       console.log(data_url)
    //     },
    //     false,
    //   )
    // }
  })
}

// Target the root element or a specific part of the DOM to observe
const targetNode = document.body

// Configure the observer
const config = {
  childList: true, // Detect additions or removals of child nodes
  subtree: true, // Observe changes in all child nodes as well
  attributes: false, // Set to true if you want to observe attribute changes
  characterData: false, // Set to true if you want to observe text node changes
}

// Create a new MutationObserver instance
const observer = new MutationObserver(onDomChange)

// Start observing the target node with the configured options
observer.observe(targetNode, config)
